// extracted by mini-css-extract-plugin
module.exports = {"container":"Design_container__iTBNx","pageHeader":"Design_pageHeader__3FR1k"};